import { CollapsedSidebar } from "@circle-react-shared/SettingsNav/CollapsedSidebar";
import { NestedNavBar } from "@circle-react-shared/SettingsNav/NestedNavBar";
import { CommunitySwitcherAppData } from "@circle-react/wrappers/CommunitySwitcherAppData";

import { t } from "@/i18n-js/instance";

export const AdminDockTree = () => (
  <div className="flex h-full flex-col overflow-hidden">
    <div className="shrink-0 px-2 py-3">
      <CommunitySwitcherAppData />
    </div>
    <nav
      className="flex min-h-0 flex-1 flex-row overflow-hidden"
      aria-label={t("circle_v4.dock.settings_nav_aria_label")}
    >
      <div className="w-16 shrink-0 overflow-hidden border-r border-primary">
        <CollapsedSidebar />
      </div>
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <div className="min-h-0 flex-1 overflow-auto">
          <NestedNavBar />
        </div>
      </div>
    </nav>
  </div>
);
